module.exports = __webpack_public_path__ + "static/media/spa.4f5611c0.jpg";